import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import Typography from "@mui/material/Typography";
import PageHeader from "../gamePlayComponents/PageHeader";
import {Box, Flex} from "reflexbox";
import SkeletonImage from "./SkeletonImage";
import Fab from "@mui/material/Fab";
import {ArrowDownward, ArrowUpward} from "@mui/icons-material";
import {useSelector} from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { courseFriendlyName, courseHasMap, courses } from "../courseContent/courseObjects";

const Map = (props) => {
  const theme = useTheme();
  const platform = useSelector((state) => state.platform);
  const {course} = useParams();
  const currentCourseName = course || null;
  const mapSource = courses[currentCourseName]?.map;
  const hasMap = courseHasMap(currentCourseName);
  const mapImage = <SkeletonImage src={mapSource} alt={'map of the tidal basin'} skeletonHeight={'900px'}/>;

  useEffect(() => {
    if (hasMap) {
      goToBottom();
    }
  }, [hasMap]);

  const goToTop = () => {
    document.getElementById("top").scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  };

  const goToBottom = () => {
    document.getElementById("bottom").scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  };

  const scrollButtons = courses[currentCourseName]?.key.includes('incoln') && (
    <Flex
      id={'buttons'}
      style={{
        position: 'fixed',
        right: 16,
        top: 100 + platform.statusBarHeight,
        flexDirection: 'column',
        alignItems: 'flex-end',
        zIndex: 10,
      }}>
      <Fab color={'primary'} aria-label="scroll to top" onClick={goToTop}>
        <ArrowUpward/>
      </Fab>
      <Fab color={'primary'} aria-label="scroll to bottom" onClick={goToBottom} style={{marginTop: '16px'}}>
        <ArrowDownward/>
      </Fab>
    </Flex>
  );

  if (!hasMap) {
    return (<>
      <Box style={{
        position: 'absolute',
        left: 0,
        top: 0,
        padding: '0 8px',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
        zIndex: 5,
        paddingTop: platform.statusBarHeight
      }}>
        <PageHeader title={'Map'} goBack/>
      </Box>
      <Box style={{ minHeight: '80px', width: '100%', backgroundColor: theme.palette.background.default }}/>
      <Flex style={{flexDirection: 'column', alignItems: 'center', padding: '24px 16px', textAlign: 'center'}}>
        <Typography variant={'body1'} style={{marginBottom: '16px'}}>
          {courseFriendlyName(currentCourseName) || 'This course'} does not include a course map.
        </Typography>
        <Typography variant={'body2'} color={'text.secondary'}>
          Use the directions link and location clues to navigate between stops.
        </Typography>
      </Flex>
    </>);
  }

  return (<>
    <Box style={{
      position: 'absolute',
      left: 0,
      top: 0,
      padding: '0 8px',
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[1],
      zIndex: 5,
      paddingTop: platform.statusBarHeight
    }}>
      <PageHeader title={'Map'} goBack/>
    </Box>
    <div id={'top'}/>
    <Box style={{ minHeight: '80px', width: '100%', backgroundColor: theme.palette.background.default }}/>
    {scrollButtons}
    <Box>
      {mapImage}
    </Box>
    <div id={'bottom'}/>
  </>)
};

export default Map;
